import { getMinTier } from "./minTier";
import type { EligibilityCode, Raffle } from "./types";

const STATIC_TEXTS: Record<Exclude<EligibilityCode, "tier_too_low">, string> = {
  private_join_required: "Join with an invite code to participate.",
  raffle_not_active: "This promo is no longer accepting participants.",
};

// Причина, почему зритель не участвует; null — участвовать может.
export const getEligibilityText = (raffle: Raffle): string | null => {
  const { eligible, code } = raffle.completion.eligibility;
  if (eligible || !code) return null;
  if (code !== "tier_too_low") return STATIC_TEXTS[code];
  const minTier = getMinTier(raffle.allowed_participant_tiers);
  return minTier
    ? `Requires ${minTier.display_name} status or higher.`
    : "Your status doesn't allow participating.";
};
